import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MarsStroke = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M376 0c-9.7 0-18.5 5.8-22.2 14.8S352.1 34.1 359 41l33.4 33.4-22.1 22L345 71c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l25.4 25.4-28.7 28.7c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l28.6-28.6L407 201c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-25.4-25.4 22.1-22.1L471 153c6.9 6.9 17.2 8.9 26.2 5.2S512 145.7 512 136V24c0-13.3-10.7-24-24-24H376zm88 48zM320 304c0 61.9-50.1 112-112 112S96 365.9 96 304s50.1-112 112-112 112 50.1 112 112z"
  }));
});
MarsStroke.displayName = 'MarsStroke';
export var MarsStrokeDimensions = {
  height: 512,
  width: 512
};